export { default as UpArrowIcon } from './icon-chevron-up.svg';
export { default as DownArrowIcon } from './icon-chevron-down.svg';
export { default as WarningIcon } from './icon-warning.svg';
export { default as HotelIcon } from './hotel.svg';
export { default as LocationIcon } from './location-pin.svg';
export { default as LocationPinIcon } from './icon-location-pin.svg';
export { default as PersonIcon } from './icon-person.svg';
export { default as PersonIcon2 } from './icon-person-2.svg';
export { default as CalendarIcon } from './icon-calendar.svg';
export { default as DeleteIcon } from './delete.svg';
export { default as Delete } from './dlt.svg';
export { default as PlusIcon } from './plus.svg';
export { default as InfoIcon } from './info.svg';
export { default as AlertIcon } from './icon-alert-circle-fill.svg';
export { default as CloseIcon } from './icon-close.svg';
export { default as SeturLogo } from './misc-setur-logo.svg';
export { default as TrashIcon } from './icon-trash.svg';
export { default as FilterIcon } from './icon-filter.svg';
export { default as SortIcon } from './icon-sort.svg';
export { default as WorldLogo } from './world-card-logo.svg';
export { default as CheckmarkIcon } from './checkmark-circle-2-outline.svg';
export { default as ScrollIcon } from './scrollToTop.svg';
export { default as SafeIcon } from './guvenli-otel.svg';
export { default as HeartIcon } from './27-icon-heart.svg';
export { default as EditIcon } from './icon-edit.svg';
export { default as CheckOutlineIcon } from './check-outline-icon.svg';
export { default as BoxIcon } from './box-icon-color.svg';
export { default as BaseCheckIcon } from './icon-check-base.svg';
export { default as NightIcon } from './icon-night.svg';
export { default as FacebookIcon } from './facebook-blue.svg';
export { default as HamburgerIcon } from './icon-hamburger.svg';
export { default as PhoneIcon } from './icon-phone.svg';
export { default as InstagramIcon } from './instagram-blue.svg';
export { default as PinterestIcon } from './pinterest-blue.svg';
export { default as TwitterIcon } from './twitter-blue.svg';
export { default as YoutubeIcon } from './youtube-blue.svg';
export { default as SeturIcon } from './setur-logo.svg';
export { default as BillIcon } from './icon-bill.svg';
export { default as KocLogo } from './koc.svg';
export { default as SeturLogoFooter } from './misc-setur-logo-footer.svg';
export { default as FacebookLogo } from './facebook.svg';
export { default as InstagramLogo } from './instagram.svg';
export { default as YoutubeLogo } from './youtube.svg';
export { default as TwitterLogo } from './twitter.svg';
export { default as PinterestLogo } from './pinterest.svg';
export { default as WhatsappLogo } from './whatsapp.svg';
export { default as RightArrowIcon } from './icon-arrow-right.svg';
export { default as TursabLogo } from './tursab.svg';
export { default as AppStoreLogo } from './appstore.svg';
export { default as PlayStoreLogo } from './playstore.svg';
export { default as RadarIcon } from './radar.svg';
export { default as ChevronRight } from './icon-chevron-right.svg';
export { default as CheckmarkOutline } from './checkmark-outline-2.svg';
export { default as OutlinkIcon } from './icon-outlink.svg';
export { default as HearthIcon } from './icon-hearth.svg';
export { default as ShareIcon } from './icon-share.svg';
export { default as SocialShareIcon } from './icon-social-share.svg';
export { default as DecrementIcon } from './icon-minus.svg';
export { default as IncrementIcon } from './icon-plus.svg';
export { default as HopiIcon } from './hopi.svg';
export { default as TurkTelekomIcon } from './turk-telekom.svg';
export { default as PlaneTakeOff } from './plane-takeoff.svg';
export { default as PlaneLanding } from './plane-landing.svg';
export { default as SquareCheck } from './icon-square-check.svg';
export { default as ChevronLeft } from './icon-chevron-left.svg';
export { default as LocationFilled } from './icon-location-fill.svg';
export { default as ChevronDown } from './down_2.svg';
export { default as ChevronUp } from './up.svg';
export { default as Info } from './icon-info.svg';
export { default as Info2 } from './icon-info-2.svg';
export { default as Notes } from './icon-notes.svg';
export { default as LimitedOption } from './limited-option.svg';
export { default as Available } from './icon-availability-available.svg';
export { default as AvailableLimited } from './icon-availability-limited.svg';
export { default as NotAvailable } from './icon-availability-not-available.svg';
export { default as ExclamationCircleIcon } from './exclamation-circle.svg';
export { default as KocAilemIcon } from './koc-ailem-turkuaz.svg';
export { default as TurkTelekomPrimeIcon } from './prime-logo.svg';
export { default as CheckInIcon } from './check-in.svg';
export { default as CheckOutIcon } from './check-out.svg';
export { default as ChangeIcon } from './icon-change.svg';
export { default as Change } from './change.svg';
export { default as ChangeVertical } from './change-vertical.svg';
export { default as ThemeTypeIcon } from './theme-type.svg';
export { default as StarIcon } from './star.svg';
export { default as PayIcon } from './pay.svg';
export { default as DurationIcon } from './icon-duration.svg';
export { default as ChainIcon } from './chain.svg';
export { default as CarIcon } from './car.svg';
export { default as HistoryIcon } from './icon-history.svg';
export { default as FireIcon } from './icon-fire.svg';
export { default as LuggageIcon } from './icon-luggage.svg';
export { default as CruiseIcon } from './icon-cruise.svg';
export { default as TourIcon } from './icon-luggage.svg';
export { default as BoatIcon } from './icon-cruise.svg';
export { default as PlaneIcon } from './icon-plane.svg';
export { default as ExpandIcon } from './icon-expand.svg';
export { default as ExitIcon } from './icon-exit.svg';
export { default as SearchIcon } from './icon-search.svg';
export { default as NotificationIcon } from './icon-notifications.svg';
export { default as FavoriteIcon } from './icon-favorite.svg';
export { default as FacebookDefault } from './facebook-default.svg';
export { default as AvailableIcon } from './icon-availibility-available.svg';
export { default as EyeIcon } from './icon-eye.svg';
export { default as EyeOffIcon } from './icon-eye-off.svg';
export { default as CheckCircle } from './check-circle-regular.svg';
export { default as MinibusIcon } from './icon-minibus.svg';
export { default as ArrowDownIcon } from './icon-arrow-down.svg';
export { default as CoinsIcon } from './coins.svg';
export { default as CreditCartIcon } from './icon-credit-card.svg';
export { default as CreditCartIconMultiple } from './icon-credit-card-multiple.svg';
export { default as GarantiPayIcon } from './garantipay.svg';
export { default as InfoIconBlue } from './icon-info-blue.svg';
export { default as ShipIcon } from './ship.svg';
export { default as NoReservationIcon } from './no-reservation.svg';
export { default as ChippinPayIcon } from './chippin-pay.svg';
export { default as HopiPayIcon } from './hopi-pay.svg';
export { default as ParoPayIcon } from './paro-pay.svg';
export { default as SeturPayIcon } from './setur-pay.svg';
export { default as WorldPayIcon } from './world-pay.svg';
export { default as BusIcon } from './icon-bus.svg';
export { default as MailIcon } from './icon-mail.svg';
export { default as ZubizuIcon } from './zubizu.svg';
export { default as TTBusiness } from './tt-business.svg';
export { default as BasketIcon } from './basket.svg';
export { default as BasketDarkIcon } from './basket-dark.svg';
export { default as PaymentIcon } from './icon-payment.svg';
export { default as TrainFilled } from './train-filled.svg';
export { default as PhoneFill } from './phone-fill.svg';
export { default as UnconditionalRefund } from './refund.svg';
export { default as SecurePayment } from './secure-payment.svg';
export { default as CustomerHappiness } from './customer-happiness.svg';
export { default as PriceGuarantee } from './price-guarantee.svg';
export { default as MastercardIcon } from './mastercard.svg';
export { default as SeturSmall } from './setur_small.svg';
export { default as PointStar } from './point-star.svg';
export { default as HandshakeRegular } from './handshake-regular.svg';
export { default as ClockIcon } from './icon-clock.svg';
export { default as ArrowLeft } from './arrow-left.svg';
export { default as CheckMark } from './check-mark.svg';
export { default as HotelBuild } from './hotel-build.svg';
export { default as ShipOutline } from './ship-outline.svg';
export { default as MapPin } from './map-pin.svg';
export { default as SwipeIcon } from './swipe.svg';
export { default as SFCreditCard } from './credit-card-sf.svg';
export { default as CardGiftIcon } from './card-gift.svg';
export { default as Announcement } from './announcement.svg';
export { default as AccessAlarm } from './access-alarm.svg';
export { default as InfoFillIcon } from './info-fill.svg';
export { default as BusinessIcon } from './business.svg';
export { default as FamilyIcon } from './family.svg';
export { default as FriendsIcon } from './friends.svg';
export { default as ProfileIcon } from './profile.svg';
export { default as TelegramIcon } from './icon-telegram.svg';
export { default as FacebookSocial } from './facebook-social.svg';
export { default as TwitterSocial } from './twitter-social.svg';
export { default as MailSocial } from './mail-social.svg';
export { default as RotateIcon } from './rotate.svg';
export { default as UserIcon } from './user.svg';
export { default as SuitcaseIcon } from './suitcase.svg';
export { default as AirbagIcon } from './airbag.svg';
export { default as AbsIcon } from './abs-icon.svg';
export { default as GasStationIcon } from './gas-station-icon.svg';
export { default as ManualTransmissionIcon } from './manual-transmission-icon.svg';
export { default as RoadIcon } from './road-icon.svg';
export { default as DateIcon } from './date-icon.svg';
export { default as DrivingLicenseIcon } from './driving-license-icon.svg';
export { default as CarDoorIcon } from './car-door.svg';
export { default as CarSeatIcon } from './car-seat.svg';
export { default as Coupon } from './coupon-line-finance.svg';
export { default as SuitCase } from './suitcase-line-map.svg';
export { default as User3 } from './user-3-line.svg';
export { default as Down } from './down-line-map.svg';
export { default as Shopping } from './shopping-cart-line.svg';
export { default as Menu } from './menu-arrow-left-s-line4.svg';
export { default as CompareArrow } from './icon-compare-arrow.svg';
export { default as Calendar2Line } from './calendar-2-line.svg';
export { default as MapPin2Line } from './map-pin-2-line.svg';
export { default as Compare } from './compare.svg';
export { default as ArrowLeftSLine } from './arrow-left-s-line-5.svg';
export { default as CheckLine } from './check-line.svg';
export { default as CloseLine } from './close-line.svg';
export { default as Line6 } from './line-6.svg';
export { default as Ellipse } from './Ellipse.svg';
export { default as Close } from './close-line-system.svg';
export { default as CloseMobil } from './close-line-mobile.svg';
export { default as Insta } from './instagram-fill-logos.svg';
export { default as Youtube } from './youtube-fill-logos.svg';
export { default as Twitter } from './twitter-fill-logos.svg';
export { default as Facebook } from './facebook-fill-logos.svg';
export { default as FilterLine } from './filter-line.svg';
export { default as PencilIcon } from './icon-pencil.svg';
export { default as ArrowLeftSLine3 } from './arrow-left-s-line-3.svg';
export { default as ArrowRightLine } from './arrow-right-line.svg';
export { default as CheckFill } from './check-fill.svg';
export { default as FlightTakeoffFill } from './flight-takeoff-fill.svg';
export { default as FlightLandFill } from './flight-land-fill.svg';
export { default as PrinterIcon } from './printer.svg';
export { default as HotelIcon2 } from './icon-hotel-2.svg';
export { default as NavigationIcon } from './icon-navigation.svg';
export { default as MapPin3Line } from './map-pin-2.svg';
export { default as ChevronDown2 } from './chevron-down-2.svg';
export { default as TimeLine } from './icon-time-line.svg';
export { default as IconPlaneFill } from './icon-plane-fill.svg';
export { default as ArrowLeftNRight } from './arrow-left-right.svg';
export { default as HazeLine } from './haze-line.svg';
export { default as HazeFill } from './haze-fill.svg';
export { default as SunLine } from './sun-line.svg';
export { default as MoonClearLive } from './moon-clear-line.svg';
export { default as ArrowLeftSLine4 } from './arrow-left-s-line-4.svg';
export { default as Edit2Line } from './edit-2-line.svg';
export { default as LeftLine } from './left-line.svg';
export { default as ArrowDownSLine } from './arrow-down-s-line.svg';
export { default as UserStar } from './user-star-line.svg';
export { default as AirlineSeatReclineNormal } from './airline-seat-recline-normal.svg';
export { default as ArrowLeftLine } from './arrow-left-line.svg';
export { default as Search2Line } from './search-2-line.svg';
export { default as DeleteBin5Line } from './delete-bin-5-line.svg';
export { default as AddFill } from './add-fill.svg';
export { default as SubtractFill } from './subtract-fill.svg';
export { default as HistoryFill } from './history-fill.svg';
export { default as HotelLine } from './hotel-line.svg';
export { default as CompassDiscoverLine } from './compass-discover-line.svg';
export { default as PlaneFill } from './plane-fill.svg';
export { default as CarLine } from './car-line.svg';
export { default as ArrowUpSLine } from './arrow-up-s-line.svg';
export { default as MediaImageLine } from './media-image-line.svg';
export { default as ArrowRightSLine } from './arrow-right-s-line.svg';
export { default as ArrowLeftSLine2 } from './icon-arrow-left-s-line.svg';
export { default as FireLine } from './fire-line.svg';
export { default as PhoneLine } from './phone-line.svg';
export { default as EditIconLine } from './edit-icon.svg';
export { default as TrashLineIcon } from './trash-line.svg';
export { default as MapLine } from './map-line.svg';
export { default as SummerIcon } from './Summer.svg';
export { default as WinterIcon } from './Winter.svg';
export { default as PlayCircleIcon } from './play_icon.svg';
export { default as Setur } from './setur.svg';
export { default as PlayVideoModalIcon } from './play-video-modal.svg';
export { default as FullScreenIcon } from './fullscreen.svg';
export { default as IconCancellationGuarantee } from './icon-cancellation-guarantee.svg';
export { default as IconInsurance } from './icon-insurance.svg';
export { default as ProfileReservation } from './profile-reservation.svg';
export { default as ShoppingCartLine } from './shopping-cart-line.svg';
export { default as SmilingStar } from './smiling-star.svg';
export { default as ExpediaFunIcon } from './expedia-fun.svg';
